import { config } from "../../config"
import { zip } from "../../helpers/utils"

export const tags = {
  readAll: ({ from = 1, limit = 1000 }) => {
    const base = config.apiUrl + `/tags`,
      opt = {}

    const params = zip([from, limit], ["f", "l"])

    let query = params
      .filter((param) => param[0] !== null && param[0] !== "")
      .map((param) => `&${param[1]}=${param[0]}`)
      .join("")

    if (query.length) query = "?" + query.substr(1)

    return { url: base + query, opt }
  },

  create: ({ token, tags }) => {
    const url = config.apiUrl + `/tags`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(tags),
      }

    return { url, opt }
  },

  update: ({ token, tag_id, tag }) => {
    const url = config.apiUrl + `/tags/${tag_id}`,
      opt = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...tag }),
      }

    return { url, opt }
  },

  delete: ({ token, tag_id }) => {
    const url = config.apiUrl + `/tags/${tag_id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    return { url, opt }
  },
}
